import { render, staticRenderFns } from "./openNode.vue?vue&type=template&id=8988dfee&"
import script from "./openNode.vue?vue&type=script&lang=js&"
export * from "./openNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports